module.exports = __webpack_public_path__ + "9d94030d9f0caa6ab5941d41c1c410f4.png";